import React, { useEffect, useState } from 'react';
import axiosInstance from '../../api/axiosInstance';

interface Notification {
  id: number;
  type: string;
  message: string;
  is_read: boolean;
  created_at: string;
}

const NotificationList: React.FC = () => {
  const [notifications, setNotifications] = useState<Notification[]>([]);

  useEffect(() => {
    axiosInstance.get('/api/notifications', {
      params: { user_id: localStorage.getItem('user_id') },
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    }).then(res => setNotifications(res.data));
  }, []);

  const markAsRead = async (id: number) => {
    await axiosInstance.put(`/api/notifications/${id}/read`, {}, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` }
    });
    setNotifications(notifications => notifications.map(n => n.id === id ? { ...n, is_read: true } : n));
  };

  return (
    <div style={{ background: '#fff', borderRadius: 12, padding: 24 }}>
      <h2>알림</h2>
      <ul>
        {notifications.map(n => (
          <li key={n.id} style={{ marginBottom: 8, color: n.is_read ? '#888' : '#222' }}>
            {n.message} <span style={{ fontSize: '0.9em', color: '#aaa' }}>({new Date(n.created_at).toLocaleString()})</span>
            {!n.is_read && <button onClick={() => markAsRead(n.id)} style={{ marginLeft: 8 }}>읽음</button>}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default NotificationList; 